import { UNLIMITED_CAPACITY } from "@salon/types";

// Frontend-specific types for capacity management
export type CapacityMode = "simple" | "advanced";

export function isInfinityLimit(value: number): boolean {
  return value >= UNLIMITED_CAPACITY;
}

export interface CapacityFormData {
  // Simple mode fields
  capacityMode: CapacityMode;
  concurrentMax: number;
  dailyMax: number;
  /** ON: a booking counts for its whole duration. OFF: only in the hour it starts. */
  durationAware: boolean;
  concurrentInfinity: boolean;
  dailyInfinity: boolean;
}
